import { apiGet, apiGetBlob, apiPostForm } from "./apiClient";

export function createCustomerTransactionSchedule(payload) {
    const formData = new FormData();

    const data = {
        requestNumber: payload.requestNumber,
        institutionId: payload.institutionId,
        registrationDateTime: payload.registrationDateTime,
        requestDateTime: payload.requestDateTime,
        currency: payload.currency,
        paymentAmount: payload.paymentAmount,
        beneficiaryCompany: payload.beneficiaryCompany,
        beneficiaryBank: payload.beneficiaryBank,
        beneficiaryAccount: payload.beneficiaryAccount,
        paymentPurpose: payload.paymentPurpose,
    };

    formData.append(
        "data",
        new Blob([JSON.stringify(data)], { type: "application/json" })
    );

    formData.append("invoiceFile", payload.invoiceFile);
    formData.append("contractFile", payload.contractFile);

    return apiPostForm("/customer-transaction-schedules", formData);
}

export function getMyCustomerTransactionSchedules() {
    return apiGet("/customer-transaction-schedules/my");
}

export function getCustomerTransactionScheduleDetail(id) {
    return apiGet(`/customer-transaction-schedules/${id}`);
}

export function downloadInvoicePdf(id) {
    return apiGetBlob(`/customer-transaction-schedules/${id}/invoice`);
}

export function downloadContractPdf(id) {
    return apiGetBlob(`/customer-transaction-schedules/${id}/contract`);
}